import React from "react";
import parse from "html-react-parser"
const Aboutus1 = ({ data }) => {
  return (
    <div className="w-full flex justify-center bg-mbabout sm:bg-aboutbg bg-cover min-h-[50vh] md:min-h-[90vh] bg-no-repeat bg-center ">
       <div className="2xl:container md:px-10 lg:px-20  mx-auto px-6 flex flex-col w-full justify-center max-sm:text-center sm:justify-end sm:pb-[80px]">
          <h1 className="max-[450px]:text-28 text-32 md:text-48 lg:text-64 text-white  lg:text-left font-bold lg:w-[70%]  w-full ">{data.Title}</h1>
       </div>
     
      {/* MARK:olddesign */}
      {/* <div className="2xl:container md:px-10 lg:px-20  mx-auto px-6 ">
        <div className="flex flex-col items-center text-center w-full gap-6">
          <h1 className="text-32 md:text-48 text-primarycolor font-semibold md:w-[85%] w-[90%] ">{data.Title}</h1>
          <p className="text-16  lg:text-18 text-secondaryblack md:w-[85%] w-[90%]">
            {parse(data.desc)}
          </p>
        </div>
        <div className="md:mt-16 mt-14 gap-3 flex flex-col items-center w-full lg:flex-row lg:h-[70vh] lg:max-h-[500px]">
          <div className="lg:w-[40%] sm:w-[70%] w-full h-full">
          <img className="w-full h-full" src={process.env.PUBLIC_URL + '/images/Aboutus/header-img.jpg'} alt="img" />
          </div>
          <div className="lg:w-[32%] sm:w-[70%] w-full h-full flex flex-col justify-between gap-3">
          <img className="w-full lg:h-[34vh] " src={process.env.PUBLIC_URL + '/images/Aboutus/header-img2.jpg'} alt="img" />
          <img className="w-full lg:h-[34vh] rounded-[24px] shadow-about" src={process.env.PUBLIC_URL + '/images/Aboutus/header-img3.jpg'} alt="img" />
          </div>

          <div className="lg:w-[28%] sm:w-[70%] w-full h-full ">
          <img className="w-full h-full max-[1025px]:max-h-[450px]" src={process.env.PUBLIC_URL + '/images/Aboutus/header-img4.jpg'} alt="img" />
          </div>

        </div>
      </div> */}
    </div>
  );
};

export default Aboutus1;
